/**
 * Created by saeed on 12/29/2016.
 */
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_SERVANTID_ANDSTARTDATE,
  API_URL_CANCEL_RESERVE,
  API_URL_APPVISER_SAVE_CLIENT_RESERVE,
  API_URL_AUTO_SELECT_SERVANT_BY_SERVICE_ID,
  API_URL_SAVE_CLIENT_RESERVE,
  API_URL_GET_AVAILABLE_CAPACITY_FOR_TIMESPAN,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDSTARTDATE,
  API_URL_PAY_ORDER_BAG,
  API_URL_GET_USER_CAN_PAY_INPLACE,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID,
  API_URL_CONFIRM_ORDER_BAG_PAYMENT,
  API_URL_GET_ORDER_BAG_BY_AUTHORITY,
  API_URL_SERVICE_OPTIONS_BY_SERVICE_ID,
  API_URL_CONFIRM_ORDER_BAG,
  API_URL_SERVICE_TIME_SESSION_BY_ID,
  API_URL_GET_ORDER_BAG_DETAIL_BY_ID,
  API_URL_GET_ORDER_BAG_LIST,
  API_URL_GET_ORDER_BAG_BY_ID,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDTIMESESSION,
  API_URL_COMPUTE_ORDER_BAG_PRICE,
  API_URL_FINAL_CONFIRM_ORDER_BAG,
  API_URL_DELETE_ORDER_BAG_BY_AUTHURITY,
  API_BASE_URL
} from '../constants';
import {CategoryVM} from "../../models/CategoryVM.model";
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {SessionDateVM} from "../../models/SessionDateVM.model";
import {SessionTimeVM} from "../../models/SessionTimeVM.model";
import {PriceInfoDetailVM} from "../../models/PriceInfoDetailVM.model";
import {ServiceOptionVM} from "../../models/ServiceOptionVM.model";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {BaseHttpService} from "../base-http-service";
import {ServantVM} from "../../models/ServiceItemDetailVM";

@Injectable()
export class PermissionService {
  // Resolve HTTP using the constructor
  constructor(private http:BaseHttpService) {


  }

  isSubscriptionValid(keyUrl:string):Observable<boolean> {
    return this.http.get(API_BASE_URL + 'api/client/can-current-company-reserve?keyUrl=' + keyUrl)
    // ...and calling .json() on the response to return data
      .map((res:Response) => {
        return res;
      })
      //...errors if any
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/permission/permission.service.ts